<template>
  <v-app>
    <v-main>
      <div>
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import store from "./store";
import "./assets/styles/fonts.css";
import "./assets/styles/appStyle.css";
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),

  beforeMount() {
    if (typeof localStorage.getItem("token") == "string") {
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            store.commit("userData", response.data.data);
            store.commit("userType", response.data.data.Type);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
};
</script>
